<script>
import moment from "moment";
import keyBy from "lodash/keyBy";
import get from "lodash/get";
import cloneDeep from "lodash/cloneDeep";
import { MapGender } from "@/common/util";
export default {
  data() {
    const patientId = this.$route.params.patientId;
    const stationId = this.$route.params.stationId;
    const patientCaseId = this.$route.params.patientCaseId;
    const doctorName = localStorage.getItem("loginName");
    const ROLE_DOCTOR =
      localStorage.getItem("roles").indexOf("ROLE_DOCTOR") > -1;
    const createdTime = moment().format("YYYY-MM-DD");
    return {
      checkBoxSelect: true,
      enabledStationUUID: undefined,
      createdTime,
      doctorName,
      ROLE_DOCTOR,
      userInfo: {},
      // value: new Date(),
      patientId,
      stationId,
      patientCaseId,
      rangeDate: {},
      caseRecord: {
        chief_complaint: undefined,
        ophthalmopathy_history: undefined,
        treatment_history: [],
        check_project: {
          vision: {
            OD: {
              far_vision_with_glasses: undefined,
              near_vision_with_glasses: undefined,
            },
            OS: {
              far_vision_with_glasses: undefined,
              near_vision_with_glasses: undefined,
            },
            eye_degree: {
              OD: {
                sign: false,
                diopter: undefined,
                astigmatic: undefined,
                axial: undefined,
              },
              OS: {
                sign: false,
                diopter: undefined,
                astigmatic: undefined,
                axial: undefined,
              },
              time_of_wearing_glasses: undefined,
            },
            fixation_property: {
              OD: undefined,
              OS: undefined,
            },
            amblyopia_type: {
              OD: undefined,
              OS: undefined,
            },
            simultaneous_perception: {
              four_hole_inspection: {
                far: undefined,
                near: undefined,
                dominant_eye: undefined,
              },
              deviation_check: {
                horizontal: undefined,
                vertical: undefined,
              },
              synoptophore_inspection: {
                has: undefined,
                content: undefined,
              },
            },
            fusion: {
              line_blending: {
                separate_range: undefined,
                convergence_range: undefined,
              },
              random_point_fusion: {
                separate_range: undefined,
                convergence_range: undefined,
              },
              synoptophore: {
                separate_range: undefined,
                convergence_range: undefined,
              },
            },
            stereoscopic_vision: {
              far: {
                synoptophore: undefined,
              },
              near: {
                line_stereopsis: undefined,
                static_random_point: undefined,
                dynamic_random_point: undefined,
                yan_style: undefined,
                Titmus: undefined,
              },
            },
            squint: null,
            AMP: {
              OD: undefined,
              OS: undefined,
              OU: undefined,
            },
            NRA: {
              OD: undefined,
              OS: undefined,
              OU: undefined,
            },
            PRA: {
              OD: undefined,
              OS: undefined,
              OU: undefined,
            },
            MEM: {
              OD: undefined,
              OS: undefined,
              OU: undefined,
            },
            FCC: {
              OD: undefined,
              OS: undefined,
              OU: undefined,
            },
            adjust_sensitivity: {
              OD: undefined,
              OS: undefined,
              OU: undefined,
            },
            horizontal_deviation: {
              far: undefined,
              near: undefined,
            },
            vertical_deviation: {
              far: undefined,
              near: undefined,
            },
            spherical_power: {
              plus: undefined,
              subtract: undefined,
            },
            ac_a_compare: {
              gradient: undefined,
              calculus: undefined,
            },
            NRV: {
              far_horizontal: undefined,
              near_horizontal: undefined,
              NPC: undefined,
            },
            PRV: {
              far_horizontal: undefined,
              near_horizontal: undefined,
            },
            adjusting_visual_target: {
              OD: undefined,
              OS: undefined,
              OU: undefined,
            },
            analyse: undefined,
            advice: undefined,
          },
        },
      },
      options: [
        {
          value: "10秒",
          label: "10秒",
        },
        {
          value: "20秒",
          label: "20秒",
        },
        {
          value: "30秒",
          label: "30秒",
        },
        {
          value: "40秒",
          label: "40秒",
        },
        {
          value: "50秒",
          label: "50秒",
        },
        {
          value: "60秒",
          label: "60秒",
        },
        {
          value: "70秒",
          label: "70秒",
        },
        {
          value: "80秒",
          label: "80秒",
        },
        {
          value: "90秒",
          label: "90秒",
        },
        {
          value: "100秒",
          label: "100秒",
        },
        {
          value: "120秒",
          label: "120秒",
        },
        {
          value: "140秒",
          label: "140秒",
        },
        {
          value: "160秒",
          label: "160秒",
        },
        {
          value: "180秒",
          label: "180秒",
        },
        {
          value: "200秒",
          label: "200秒",
        },
        {
          value: "250秒",
          label: "250秒",
        },
        {
          value: "300秒",
          label: "300秒",
        },
        {
          value: "350秒",
          label: "350秒",
        },
        {
          value: "400秒",
          label: "400秒",
        },
        {
          value: "450秒",
          label: "450秒",
        },
        {
          value: "500秒",
          label: "500秒",
        },
        {
          value: "550秒",
          label: "550秒",
        },
        {
          value: "600秒",
          label: "600秒",
        },
        {
          value: "650秒",
          label: "650秒",
        },
        {
          value: "700秒",
          label: "700秒",
        },
        {
          value: "750秒",
          label: "750秒",
        },
        {
          value: ">=800秒",
          label: ">=800秒",
        },
      ],
      options2: [
        {
          value: "0.01(3.0)",
          label: "0.01(3.0)",
        },
        {
          value: "0.012(3.1)",
          label: "0.012(3.1)",
        },
        {
          value: "0.015(3.2)",
          label: "0.015(3.2)",
        },
        {
          value: "0.02(3.3)",
          label: "0.02(3.3)",
        },
        {
          value: "0.025(3.4)",
          label: "0.025(3.4)",
        },
        {
          value: "0.03(3.5)",
          label: "0.03(3.5)",
        },
        {
          value: "0.04(3.6)",
          label: "0.04(3.6)",
        },
        {
          value: "0.05(3.7)",
          label: "0.05(3.7)",
        },
        {
          value: "0.06(3.8)",
          label: "0.06(3.8)",
        },
        {
          value: "0.08(3.9)",
          label: "0.08(3.9)",
        },
        {
          value: "0.1(4.0)",
          label: "0.1(4.0)",
        },
        {
          value: "0.125(4.1)",
          label: "0.125(4.1)",
        },
        {
          value: "0.15(4.2)",
          label: "0.15(4.2)",
        },
        {
          value: "0.2(4.3)",
          label: "0.2(4.3)",
        },
        {
          value: "0.25(4.4)",
          label: "0.25(4.4)",
        },
        {
          value: "0.3(4.5)",
          label: "0.3(4.5)",
        },
        {
          value: "0.4(4.6)",
          label: "0.4(4.6)",
        },
        {
          value: "0.5(4.7)",
          label: "0.5(4.7)",
        },
        {
          value: "0.6(4.8)",
          label: "0.6(4.8)",
        },
        {
          value: "0.7",
          label: "0.7",
        },
        {
          value: "0.8(4.9)",
          label: "0.8(4.9)",
        },
        {
          value: "0.9",
          label: "0.9",
        },
        {
          value: "1.0(5.0)",
          label: "1.0(5.0)",
        },
        {
          value: "1.2(5.1)",
          label: "1.2(5.1)",
        },
        {
          value: "1.5(5.2)",
          label: "1.5(5.2)",
        },
        {
          value: "2.0(5.3)",
          label: "2.0(5.3)",
        },
      ],
      EditCS: true,
    };
  },
  created() {
    this.loadData();
  },
  // watch: {
  //   caseRecord(caseRecord) {
  //     console.log("-->>>??", caseRecord);
  //     const anyWarning = document.getElementsByClassName("warning-Item")[0];
  //     anyWarning.className = anyWarning.className.replace("warning-Item", "");
  //   }
  // },
  methods: {
    async loadData(date) {
      if (this.patientCaseId !== "created") {
        const caseRecord = await this.$http.getPatientCaseRecordDetial(
          this.patientCaseId
        );
        if (caseRecord.content) {
          this.caseRecord = caseRecord.content;
        }
        this.enabledStationUUID = caseRecord.enabledStationUUID;
      }
      let data = await this.$http.DoctorGetPatientDetailByPatientId(
        this.patientId
      );
      if (data) {
        this.userInfo = cloneDeep(data);
        this.userInfo.gender = MapGender(data.gender);
      }
    },
    async onClick() {
      const anyWarning = document.getElementsByClassName("warning-Item");
      if (anyWarning.length > 0) {
        const anyWarningItem = anyWarning[0];
        anyWarningItem.className = anyWarningItem.className.replace(
          "warning-Item",
          ""
        );
      }

      const checkMust = [
        "OD.far_vision_with_glasses",
        // "OD.near_vision_with_glasses",
        "OS.far_vision_with_glasses",
        // "OS.near_vision_with_glasses",
        "amblyopia_type.OD",
        "amblyopia_type.OS",
        // "simultaneous_perception.four_hole_inspection.far",
        // "simultaneous_perception.four_hole_inspection.near",
        // "simultaneous_perception.four_hole_inspection.dominant_eye",
        // "simultaneous_perception.deviation_check.horizontal",
        // "simultaneous_perception.deviation_check.vertical",
        // "simultaneous_perception.synoptophore_inspection.has",
        // "simultaneous_perception.deviation_check.vertical",
        // "fusion.random_point_fusion.convergence_range",
        // "fusion.random_point_fusion.separate_range"
      ];
      const mapWarning = {
        "OD.far_vision_with_glasses": "warningItem1",
        // "OD.near_vision_with_glasses": "warningItem2",
        "OS.far_vision_with_glasses": "warningItem2",
        // "OS.near_vision_with_glasses": "warningItem4",
        "amblyopia_type.OD": "warningItem5",
        "amblyopia_type.OS": "warningItem6",
        // "simultaneous_perception.four_hole_inspection.far": "warningItem7",
        // "simultaneous_perception.four_hole_inspection.near": "warningItem8",
        // "simultaneous_perception.four_hole_inspection.dominant_eye":
        //   "warningItem9",
        // "simultaneous_perception.deviation_check.horizontal": "warningItem10",
        // "simultaneous_perception.deviation_check.vertical": "warningItem11",
        // "simultaneous_perception.synoptophore_inspection.has": "warningItem12",
        // "fusion.random_point_fusion.convergence_range": "warningItem13",
        // "fusion.random_point_fusion.separate_range": "warningItem14"
      };
      let hasUndefined = false;
      for (let item in checkMust) {
        const checkValue = get(
          this.caseRecord.check_project.vision,
          checkMust[item]
        );
        if (checkValue === undefined) {
          const jumpItem = document.getElementsByClassName(
            mapWarning[checkMust[item]]
          )[0];
          jumpItem.scrollIntoView(true);
          jumpItem.className = jumpItem.className + " warning-Item";
          this.$message.warning("请补完必填选项！");
          hasUndefined = true;
          break;
        }
      }
      const listResult = {
        OD_far_vision_with_glasses:
          this.caseRecord.check_project.vision.OD.far_vision_with_glasses,
        OD_near_vision_with_glasses:
          this.caseRecord.check_project.vision.OD.near_vision_with_glasses,
        OS_far_vision_with_glasses:
          this.caseRecord.check_project.vision.OS.far_vision_with_glasses,
        OS_near_vision_with_glasses:
          this.caseRecord.check_project.vision.OS.near_vision_with_glasses,
      };
      if (!hasUndefined) {
        const data = {
          doctor: this.doctorName,
          nurse: "",
          checkType: "HOSPITAL_CHECK",
          content: this.caseRecord,
          caseResult: listResult,
          stationUUID: this.stationId,
        };
        if (this.patientCaseId !== "created") {
          data.patientCaseId = this.patientCaseId;
        }
        const result = await this.$http.saveCaseRecord(data, this.patientId);
        if (result === "success") {
          this.$message.success("提交成功");
          this.$cookie.set("tempTabLabel", "患者病历");
          this.$router.push({
            path: `/index/patientManagement/patientManagementDetail/${this.patientId}/${this.stationId}`,
          });
        }
      }
    },
  },
};
</script>

<template>
  <div class="PatientManagementCaseRecordIndex">
    <el-breadcrumb class="headerLinkView" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>您的位置：</el-breadcrumb-item>
      <el-breadcrumb-item
        :replace="true"
        :to="{ path: '/index/patientManagement' }"
        >患者管理</el-breadcrumb-item
      >
      <el-breadcrumb-item
        :replace="true"
        :to="{
          path: `/index/patientManagement/patientManagementDetail/${patientId}/${stationId}`,
        }"
        >患者详情</el-breadcrumb-item
      >
      <el-breadcrumb-item>检查记录</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="csContentEdit" v-if="EditCS">
      <el-card class="box-card caseRecordHead" shadow="never">
        <el-row :gutter="24">
          <el-col :span="3" class="titleCell">责任医师</el-col>
          <el-col :span="5">{{ doctorName }}</el-col>
          <el-col :span="3" class="titleCell">负责护士</el-col>
          <el-col :span="5">--</el-col>
          <el-col :span="3" class="titleCell">病历日期</el-col>
          <el-col :span="5">{{ createdTime }}</el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="3" class="titleCell">姓名</el-col>
          <el-col :span="5">{{ userInfo.name }}</el-col>
          <el-col :span="3" class="titleCell">性别</el-col>
          <el-col :span="5">{{ userInfo.gender }}</el-col>
          <el-col :span="3" class="titleCell">出生日期</el-col>
          <el-col :span="5">{{ userInfo.birth }}</el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="3" class="titleCell">联系地址</el-col>
          <el-col :span="21">{{ userInfo.contactLocation }}</el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="3" class="titleCell">联系电话</el-col>
          <el-col :span="21">{{ userInfo.phone }}</el-col>
        </el-row>
      </el-card>
      <el-card class="box-card caseRecordHistory" shadow="never">
        <el-row :gutter="24" class="el-row-textarea">
          <el-col :span="3" class="titelCellTextTitle">主诉</el-col>
          <el-col :span="21">
            <el-input
              type="textarea"
              :rows="3"
              class="titelCellTextArea"
              placeholder="请输入内容"
              v-model="caseRecord.chief_complaint"
            ></el-input>
          </el-col>
        </el-row>
        <el-row :gutter="24" class="el-row-textarea">
          <el-col :span="3" class="titelCellTextTitle">眼部病史</el-col>
          <el-col :span="21">
            <el-input
              type="textarea"
              :rows="3"
              class="titelCellTextArea"
              placeholder="请输入内容"
              v-model="caseRecord.ophthalmopathy_history"
            ></el-input>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="3" class="titleCell">治疗史</el-col>
          <el-col :span="21">
            <el-checkbox-group v-model="caseRecord.treatment_history">
              <el-checkbox label="OCCLUSION_THERAPY">遮盖治疗</el-checkbox>
              <el-checkbox label="AMBLYOPIA_THERAPY">弱视治疗</el-checkbox>
              <el-checkbox label="STRABOTOMY">斜视手术</el-checkbox>
            </el-checkbox-group>
          </el-col>
        </el-row>
      </el-card>
      <el-card class="box-card caseRecordAssay" shadow="never">
        <el-row :gutter="24" class="el-row-out">
          <el-col :span="3" class="titleCell el-col-right">项目</el-col>
          <el-col :span="21">
            <el-row :gutter="24">
              <el-col :span="12" class="titleCell el-col-right"
                >右眼(OD)</el-col
              >
              <el-col :span="12" class="titleCell">左眼(OS)</el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-row :gutter="24" class="el-row-out">
          <el-col :span="3" class="titleCellItem el-col-right">
            <el-row :gutter="24">
              <el-col>视力</el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col>(标准对数)</el-col>
            </el-row>
          </el-col>
          <el-col :span="21">
            <el-row :gutter="24" class="el-row-in">
              <el-col :span="12" class="el-col-right warningItem1">
                戴镜远视力
                <span class="mustItem">*</span>
                <el-select
                  v-model="
                    caseRecord.check_project.vision.OD.far_vision_with_glasses
                  "
                  class="eyeDegreeSelect"
                  size="mini"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in options2"
                    :key="item.value + 'odFar_vision_with_glasses'"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-col>
              <el-col :span="12" class="warningItem2">
                戴镜远视力
                <span class="mustItem">*</span>
                <el-select
                  v-model="
                    caseRecord.check_project.vision.OS.far_vision_with_glasses
                  "
                  class="eyeDegreeSelect"
                  size="mini"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in options2"
                    :key="item.value + 'osFar_vision_with_glasses'"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12" class="el-col-right warningItem3">
                戴镜近视力
                <el-select
                  v-model="
                    caseRecord.check_project.vision.OD.near_vision_with_glasses
                  "
                  class="eyeDegreeSelect"
                  size="mini"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in options2"
                    :key="item.value + 'Od_near_vision_with_glasses'"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-col>
              <el-col :span="12" class="warningItem4">
                戴镜近视力
                <el-select
                  v-model="
                    caseRecord.check_project.vision.OS.near_vision_with_glasses
                  "
                  class="eyeDegreeSelect"
                  size="mini"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in options2"
                    :key="item.value + 'Os_near_vision_with_glasses'"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-row :gutter="24" class="el-row-out">
          <el-col :span="3" class="titleCellItem">验光度数</el-col>
          <el-col :span="21" class="el-col-left">
            <el-row :gutter="24" class="el-row-in">
              <el-col :span="12" class="el-col-right">
                <el-checkbox
                  v-model="caseRecord.check_project.vision.eye_degree.OD.sign"
                  :style="{ 'margin-right': '-5px' }"
                  >负号</el-checkbox
                >
                <el-input-number
                  v-model="
                    caseRecord.check_project.vision.eye_degree.OD.diopter
                  "
                  :precision="2"
                  :step="0.25"
                  :step-strictly="true"
                  controls-position="right"
                  class="eyeDegreeNumberInput"
                  size="mini"
                ></el-input-number
                >/
                <el-input-number
                  v-model="
                    caseRecord.check_project.vision.eye_degree.OD.astigmatic
                  "
                  :precision="2"
                  :step="0.25"
                  :step-strictly="true"
                  controls-position="right"
                  class="eyeDegreeNumberInput"
                  size="mini"
                ></el-input-number
                >×
                <el-input-number
                  v-model="caseRecord.check_project.vision.eye_degree.OD.axial"
                  :controls="false"
                  :step-strictly="true"
                  :max="360"
                  :min="0"
                  class="eyeDegreeNumberInput"
                  wi
                  size="mini"
                ></el-input-number>
              </el-col>
              <el-col :span="12">
                <el-checkbox
                  v-model="caseRecord.check_project.vision.eye_degree.OS.sign"
                  :style="{ 'margin-right': '-5px' }"
                  >负号</el-checkbox
                >
                <el-input-number
                  v-model="
                    caseRecord.check_project.vision.eye_degree.OS.diopter
                  "
                  :precision="2"
                  :step="0.25"
                  :step-strictly="true"
                  controls-position="right"
                  class="eyeDegreeNumberInput"
                  size="mini"
                ></el-input-number
                >/
                <el-input-number
                  v-model="
                    caseRecord.check_project.vision.eye_degree.OS.astigmatic
                  "
                  :precision="2"
                  :step="0.25"
                  :step-strictly="true"
                  controls-position="right"
                  class="eyeDegreeNumberInput"
                  size="mini"
                ></el-input-number
                >×
                <el-input-number
                  v-model="caseRecord.check_project.vision.eye_degree.OS.axial"
                  :controls="false"
                  :step-strictly="true"
                  :max="360"
                  :min="0"
                  class="eyeDegreeNumberInput"
                  size="mini"
                ></el-input-number>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="24">
                戴镜时间：
                <el-date-picker
                  v-model="
                    caseRecord.check_project.vision.eye_degree
                      .time_of_wearing_glasses
                  "
                  type="date"
                  placeholder="选择日期"
                  class="eyeDegreeDateSelect"
                  size="mini"
                ></el-date-picker>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-row :gutter="24" class="el-row-out">
          <el-col :span="3" class="titleCellItem">注视性质</el-col>
          <el-col :span="21">
            <el-row :gutter="24">
              <el-col :span="12" class="el-col-left">
                <el-row :gutter="24" class="el-row-in">
                  <el-col :span="24" class="el-col-right">
                    <el-radio
                      v-model="
                        caseRecord.check_project.vision.fixation_property.OD
                      "
                      label="CENTRAL_FIXATION"
                      >中心注视(0 ～ 1°)</el-radio
                    >
                  </el-col>
                </el-row>
                <el-row :gutter="24" class="el-row-in">
                  <el-col :span="24" class="el-col-right">
                    <el-radio
                      v-model="
                        caseRecord.check_project.vision.fixation_property.OD
                      "
                      label="ECCENTRIC_FIXATION"
                      >旁中心注视(1 ～ 3°)</el-radio
                    >
                  </el-col>
                </el-row>
                <el-row :gutter="24" class="el-row-in">
                  <el-col :span="24" class="el-col-right">
                    <el-radio
                      v-model="
                        caseRecord.check_project.vision.fixation_property.OD
                      "
                      label="MACULAR_GAZE"
                      >黄斑注视(3 ～ 5°)</el-radio
                    >
                  </el-col>
                </el-row>
                <el-row :gutter="24" class="el-row-in">
                  <el-col :span="24" class="el-col-right">
                    <el-radio
                      v-model="
                        caseRecord.check_project.vision.fixation_property.OD
                      "
                      label="PERIPHERAL_FIXATION"
                      >周边注视注视(>5°)</el-radio
                    >
                  </el-col>
                </el-row>
                <el-row :gutter="24">
                  <el-col :span="24" class="el-col-right">
                    <el-radio
                      v-model="
                        caseRecord.check_project.vision.fixation_property.OD
                      "
                      label="POOR_FIXATION"
                      >固视不良</el-radio
                    >
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="12">
                <el-row :gutter="24" class="el-row-in">
                  <el-col :span="24">
                    <el-radio
                      v-model="
                        caseRecord.check_project.vision.fixation_property.OS
                      "
                      label="CENTRAL_FIXATION"
                      >中心注视(0 ～ 1°)</el-radio
                    >
                  </el-col>
                </el-row>
                <el-row :gutter="24" class="el-row-in">
                  <el-col :span="24">
                    <el-radio
                      v-model="
                        caseRecord.check_project.vision.fixation_property.OS
                      "
                      label="ECCENTRIC_FIXATION"
                      >旁中心注视(1 ～ 3°)</el-radio
                    >
                  </el-col>
                </el-row>
                <el-row :gutter="24" class="el-row-in">
                  <el-col :span="24">
                    <el-radio
                      v-model="
                        caseRecord.check_project.vision.fixation_property.OS
                      "
                      label="MACULAR_GAZE"
                      >黄斑注视(3 ～ 5°)</el-radio
                    >
                  </el-col>
                </el-row>
                <el-row :gutter="24" class="el-row-in">
                  <el-col :span="24">
                    <el-radio
                      v-model="
                        caseRecord.check_project.vision.fixation_property.OS
                      "
                      label="PERIPHERAL_FIXATION"
                      >周边注视注视(>5°)</el-radio
                    >
                  </el-col>
                </el-row>
                <el-row :gutter="24">
                  <el-col :span="24">
                    <el-radio
                      v-model="
                        caseRecord.check_project.vision.fixation_property.OS
                      "
                      label="POOR_FIXATION"
                      >固视不良</el-radio
                    >
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-row :gutter="24" class="el-row-out">
          <el-col :span="3" class="titleCellItem">
            弱视类型
            <span class="mustItem">*</span>
          </el-col>
          <el-col :span="21">
            <el-row :gutter="24">
              <el-col :span="12" class="el-col-left warningItem5">
                <el-row :gutter="24" class="el-row-in">
                  <el-col :span="24">
                    <el-radio
                      v-model="
                        caseRecord.check_project.vision.amblyopia_type.OD
                      "
                      label="GOOD"
                      >视力正常</el-radio
                    >
                  </el-col>
                </el-row>
                <el-row :gutter="24" class="el-row-in">
                  <el-col :span="24">
                    <el-radio
                      v-model="
                        caseRecord.check_project.vision.amblyopia_type.OD
                      "
                      label="AMETROPIC_AMBLYOPIA"
                      >屈光不正性弱视</el-radio
                    >
                  </el-col>
                </el-row>
                <el-row :gutter="24" class="el-row-in">
                  <el-col :span="24">
                    <el-radio
                      v-model="
                        caseRecord.check_project.vision.amblyopia_type.OD
                      "
                      label="ANISOMETROPIC_AMBLYOPIA"
                      >屈光参差性弱视</el-radio
                    >
                  </el-col>
                </el-row>
                <el-row :gutter="24" class="el-row-in">
                  <el-col :span="24">
                    <el-radio
                      v-model="
                        caseRecord.check_project.vision.amblyopia_type.OD
                      "
                      label="STRABISMIC_AMBLYOPIA"
                      >斜视性弱视</el-radio
                    >
                  </el-col>
                </el-row>
                <el-row :gutter="24">
                  <el-col :span="24">
                    <el-radio
                      v-model="
                        caseRecord.check_project.vision.amblyopia_type.OD
                      "
                      label="DEPRIVATION_AMBLYOPIA"
                      >形觉剥夺性弱视</el-radio
                    >
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="12" class="el-col-left warningItem6">
                <el-row :gutter="24">
                  <el-col :span="24" class="el-row-in">
                    <el-radio
                      v-model="
                        caseRecord.check_project.vision.amblyopia_type.OS
                      "
                      label="GOOD"
                      >视力正常</el-radio
                    >
                  </el-col>
                </el-row>
                <el-row :gutter="24" class="el-row-in">
                  <el-col :span="24">
                    <el-radio
                      v-model="
                        caseRecord.check_project.vision.amblyopia_type.OS
                      "
                      label="AMETROPIC_AMBLYOPIA"
                      >屈光不正性弱视</el-radio
                    >
                  </el-col>
                </el-row>
                <el-row :gutter="24" class="el-row-in">
                  <el-col :span="24">
                    <el-radio
                      v-model="
                        caseRecord.check_project.vision.amblyopia_type.OS
                      "
                      label="ANISOMETROPIC_AMBLYOPIA"
                      >屈光参差性弱视</el-radio
                    >
                  </el-col>
                </el-row>
                <el-row :gutter="24" class="el-row-in">
                  <el-col :span="24">
                    <el-radio
                      v-model="
                        caseRecord.check_project.vision.amblyopia_type.OS
                      "
                      label="STRABISMIC_AMBLYOPIA"
                      >斜视性弱视</el-radio
                    >
                  </el-col>
                </el-row>
                <el-row :gutter="24">
                  <el-col :span="24">
                    <el-radio
                      v-model="
                        caseRecord.check_project.vision.amblyopia_type.OS
                      "
                      label="DEPRIVATION_AMBLYOPIA"
                      >形觉剥夺性弱视</el-radio
                    >
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-row :gutter="24" class="el-row-out">
          <el-col :span="3" class="titleCellItem">
            同时知觉
            <!-- <span class="mustItem">*</span> -->
          </el-col>
          <el-col :span="21" class="el-col-left">
            <el-row :gutter="24" class="el-row-in">
              <el-col :span="4" class="titleCellItem">四孔检查</el-col>
              <el-col :span="20" class="el-col-left">
                <el-row :gutter="24" class="el-row-in warningIte7 warningItem8">
                  <el-col :span="24">
                    远：
                    <el-radio-group
                      v-model="
                        caseRecord.check_project.vision.simultaneous_perception
                          .four_hole_inspection.far
                      "
                      class="eyeAssayRadioGroup"
                    >
                      <el-radio label="5">5</el-radio>
                      <el-radio label="4">4</el-radio>
                      <el-radio label="3">3</el-radio>
                      <el-radio label="2">2</el-radio>
                      <el-radio label="1">交替抑制</el-radio>
                      </el-radio-group
                    >近：
                    <el-radio-group
                      v-model="
                        caseRecord.check_project.vision.simultaneous_perception
                          .four_hole_inspection.near
                      "
                      class="eyeAssayRadioGroup"
                    >
                      <el-radio label="5">5</el-radio>
                      <el-radio label="4">4</el-radio>
                      <el-radio label="3">3</el-radio>
                      <el-radio label="2">2</el-radio>
                      <el-radio label="1">交替抑制</el-radio>
                    </el-radio-group>
                  </el-col>
                </el-row>
                <el-row :gutter="24" class="warningItem9">
                  <el-col :span="24">
                    主导眼
                    <el-radio-group
                      v-model="
                        caseRecord.check_project.vision.simultaneous_perception
                          .four_hole_inspection.dominant_eye
                      "
                      class="eyeAssayRadioGroup"
                    >
                      <el-radio label="RIGHT_EYE">右眼</el-radio>
                      <el-radio label="LEFT_EYE">左眼</el-radio>
                    </el-radio-group>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
            <el-row :gutter="24" class="el-row-in">
              <el-col
                :span="4"
                class="titleCellItem warningItem10 warningItem11"
                >偏差检查</el-col
              >
              <el-col :span="20" class="el-col-left">
                <span class="assayInputSmallSpan">
                  水平偏差：
                  <el-input-number
                    v-model="
                      caseRecord.check_project.vision.simultaneous_perception
                        .deviation_check.horizontal
                    "
                    :controls="false"
                    :precision="2"
                    :max="360"
                    :min="-360"
                    class="eyeDegreeNumberInput"
                    size="mini"
                  ></el-input-number
                  >度
                </span>
                <span>
                  垂直偏差：
                  <el-input-number
                    v-model="
                      caseRecord.check_project.vision.simultaneous_perception
                        .deviation_check.vertical
                    "
                    :controls="false"
                    :precision="2"
                    :max="360"
                    :min="-360"
                    class="eyeDegreeNumberInput"
                    size="mini"
                  ></el-input-number
                  >度
                </span>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="4" class="titleCellItem warningItem12"
                >同视机检查</el-col
              >
              <el-col :span="20" class="el-col-left">
                <el-radio-group
                  v-model="
                    caseRecord.check_project.vision.simultaneous_perception
                      .synoptophore_inspection.has
                  "
                >
                  <el-radio :label="true">有同时知觉</el-radio>
                  <el-radio :label="false">无同时知觉</el-radio>
                </el-radio-group>
                <span>
                  <el-input
                    v-model="
                      caseRecord.check_project.vision.simultaneous_perception
                        .synoptophore_inspection.content
                    "
                    class="assayInputBig"
                    size="small"
                  ></el-input>
                </span>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-row :gutter="24" class="el-row-out">
          <el-col :span="3" class="titleCellItem">融合功能</el-col>
          <el-col :span="21" class="el-col-left">
            <el-row :gutter="24" class="el-row-in">
              <el-col :span="4" class="titleCellItem">线条融合</el-col>
              <el-col :span="20" class="el-col-left">
                <span class="assayInputSmallSpan">
                  分开范围: -
                  <el-input-number
                    v-model="
                      caseRecord.check_project.vision.fusion.line_blending
                        .separate_range
                    "
                    :controls="false"
                    :precision="2"
                    :max="360"
                    :min="0"
                    class="eyeDegreeNumberInput"
                    size="mini"
                  ></el-input-number
                  >度
                </span>
                <span>
                  辐辏范围: +
                  <el-input-number
                    v-model="
                      caseRecord.check_project.vision.fusion.line_blending
                        .convergence_range
                    "
                    :controls="false"
                    :precision="2"
                    :max="360"
                    :min="0"
                    class="eyeDegreeNumberInput"
                    size="mini"
                  ></el-input-number
                  >度
                </span>
              </el-col>
            </el-row>
            <el-row :gutter="24" class="el-row-in">
              <el-col :span="4" class="titleCellItem el-col-right"
                >随机点融合(800秒)</el-col
              >
              <el-col
                :span="20"
                class="OverHeightCol warningItem13 warningItem14"
              >
                <span class="assayInputSmallSpan">
                  分开范围: -
                  <el-input-number
                    v-model="
                      caseRecord.check_project.vision.fusion.random_point_fusion
                        .separate_range
                    "
                    :controls="false"
                    :precision="2"
                    :max="360"
                    :min="0"
                    class="eyeDegreeNumberInput"
                    size="mini"
                  ></el-input-number
                  >度
                </span>
                <span>
                  辐辏范围: +
                  <el-input-number
                    v-model="
                      caseRecord.check_project.vision.fusion.random_point_fusion
                        .convergence_range
                    "
                    :controls="false"
                    :precision="2"
                    :max="360"
                    :min="0"
                    class="eyeDegreeNumberInput"
                    size="mini"
                  ></el-input-number
                  >度
                </span>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="4" class="titleCellItem">同视机</el-col>
              <el-col :span="20" class="el-col-left">
                <span class="assayInputSmallSpan">
                  分开范围: -
                  <el-input-number
                    v-model="
                      caseRecord.check_project.vision.fusion.synoptophore
                        .separate_range
                    "
                    :controls="false"
                    :precision="2"
                    :max="360"
                    :min="0"
                    class="eyeDegreeNumberInput"
                    size="mini"
                  ></el-input-number
                  >度
                </span>
                <span>
                  辐辏范围: +
                  <el-input-number
                    v-model="
                      caseRecord.check_project.vision.fusion.synoptophore
                        .convergence_range
                    "
                    :controls="false"
                    :precision="2"
                    :max="360"
                    :min="0"
                    class="eyeDegreeNumberInput"
                    size="mini"
                  ></el-input-number
                  >度
                </span>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-row :gutter="24" class="el-row-out">
          <el-col :span="3" class="titleCellItem">立体视觉</el-col>
          <el-col :span="21" class="el-col-left">
            <el-row :gutter="24" class="el-row-in">
              <el-col :span="4" class="titleCellItem">远</el-col>
              <el-col :span="20" class="el-col-left">
                <span>
                  同视机
                  <el-select
                    v-model="
                      caseRecord.check_project.vision.stereoscopic_vision.far
                        .synoptophore
                    "
                    placeholder="请选择"
                    size="mini"
                    class="eyeDegreeSelect"
                  >
                    <el-option key="+" label="+" value="+"></el-option>
                    <el-option key="-" label="-" value="-"></el-option>
                    <el-option
                      v-for="item in options"
                      :key="item.value + 'synoptophore' "
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </span>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="4" class="titleCellItem">近</el-col>
              <el-col :span="20" class="el-col-left">
                <el-row :gutter="24" class="el-row-in">
                  <el-col :span="24">
                    <span>
                      线条立体视
                      <el-select
                        v-model="
                          caseRecord.check_project.vision.stereoscopic_vision
                            .near.line_stereopsis
                        "
                        placeholder="请选择"
                        size="mini"
                        class="eyeDegreeSelect"
                      >
                        <el-option
                          v-for="item in options"
                          :key="item.value + 'line_stereopsis'"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </span>
                    <span>
                      静态随机点
                      <el-select
                        v-model="
                          caseRecord.check_project.vision.stereoscopic_vision
                            .near.static_random_point
                        "
                        placeholder="请选择"
                        size="mini"
                        class="eyeDegreeSelect"
                      >
                        <el-option
                          v-for="item in options"
                          :key="item.value + 'static_random_point'"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </span>
                    <span>
                      动态随机点
                      <el-select
                        v-model="
                          caseRecord.check_project.vision.stereoscopic_vision
                            .near.dynamic_random_point
                        "
                        placeholder="请选择"
                        size="mini"
                        class="eyeDegreeSelect"
                      >
                        <el-option
                          v-for="item in options"
                          :key="item.value + 'dynamic_random_point'"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </span>
                  </el-col>
                </el-row>
                <el-row :gutter="24">
                  <el-col :span="24">
                    <span>
                      颜氏
                      <el-select
                        v-model="
                          caseRecord.check_project.vision.stereoscopic_vision
                            .near.yan_style
                        "
                        placeholder="请选择"
                        size="mini"
                        class="eyeDegreeSelect"
                      >
                        <el-option
                          v-for="item in options"
                          :key="item.value + 'yan_style'"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </span>
                    <span>
                      Titmus
                      <el-select
                        v-model="
                          caseRecord.check_project.vision.stereoscopic_vision
                            .near.Titmus
                        "
                        placeholder="请选择"
                        size="mini"
                        class="eyeDegreeSelect"
                      >
                        <el-option
                          v-for="item in options"
                          :key="item.value + 'Titmus'"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </span>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-row :gutter="24" class="el-row-out">
          <el-col :span="3" class="titleCellItem">斜视</el-col>
          <el-col :span="21" class="el-col-left">
            <el-radio-group v-model="caseRecord.check_project.vision.squint">
              <el-radio label="NORMOTOPIA">正位</el-radio>
              <el-radio label="HETEROPHORIA">隐斜视</el-radio>
              <el-radio label="EXOTROPIA">外斜视</el-radio>
              <el-radio label="ESOTROPIA">内斜视</el-radio>
              <el-radio label="A_V_OTROPIA">A-V型斜视</el-radio>
              <el-radio label="VERTICAL_ROTATION_STRABISMUS"
                >垂直旋转性斜视</el-radio
              >
              <el-radio label="CENTRAL_PARALYTIC_STRABISMUS"
                >中枢性麻痹性斜视</el-radio
              >
              <el-radio label="NYSTAGMUS">眼球震颤</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row :gutter="24" class="el-row-out">
          <el-col :span="3" class="titleCellItem">调节幅度</el-col>
          <el-col :span="21" class="el-col-left">
            <span>
              OD:
              <el-input
                v-model="caseRecord.check_project.vision.AMP.OD"
                class="assayInput"
                size="small"
                placeholder="请输入内容"
              ></el-input>
            </span>
            <span>
              OS:
              <el-input
                v-model="caseRecord.check_project.vision.AMP.OS"
                class="assayInput"
                size="small"
                placeholder="请输入内容"
              ></el-input>
            </span>
            <span>
              OU:
              <el-input
                v-model="caseRecord.check_project.vision.AMP.OU"
                class="assayInput"
                size="small"
                placeholder="请输入内容"
              ></el-input>
            </span>
          </el-col>
        </el-row>
        <el-row :gutter="24" class="el-row-out">
          <el-col :span="3" class="titleCellItem el-col-right"
            >负相对调节（NRA）</el-col
          >
          <el-col :span="21" class="OverHeightCol">
            <span>
              OD:
              <el-input
                v-model="caseRecord.check_project.vision.NRA.OD"
                class="assayInput"
                size="small"
                placeholder="请输入内容"
              ></el-input>
            </span>
            <span>
              OS:
              <el-input
                v-model="caseRecord.check_project.vision.NRA.OS"
                class="assayInput"
                size="small"
                placeholder="请输入内容"
              ></el-input>
            </span>
            <span>
              OU:
              <el-input
                v-model="caseRecord.check_project.vision.NRA.OU"
                class="assayInput"
                size="small"
                placeholder="请输入内容"
              ></el-input>
            </span>
          </el-col>
        </el-row>
        <el-row :gutter="24" class="el-row-out">
          <el-col :span="3" class="titleCellItem el-col-right"
            >正相对调节（PRA）</el-col
          >
          <el-col :span="21" class="OverHeightCol">
            <span>
              OD:
              <el-input
                v-model="caseRecord.check_project.vision.PRA.OD"
                class="assayInput"
                size="small"
                placeholder="请输入内容"
              ></el-input>
            </span>
            <span>
              OS:
              <el-input
                v-model="caseRecord.check_project.vision.PRA.OS"
                class="assayInput"
                size="small"
                placeholder="请输入内容"
              ></el-input>
            </span>
            <span>
              OU:
              <el-input
                v-model="caseRecord.check_project.vision.PRA.OU"
                class="assayInput"
                size="small"
                placeholder="请输入内容"
              ></el-input>
            </span>
          </el-col>
        </el-row>
        <el-row :gutter="24" class="el-row-out">
          <el-col :span="3" class="titleCellItem el-col-right"
            >MEM动态检影法</el-col
          >
          <el-col :span="21" class="OverHeightCol">
            <span>
              OD:
              <el-input
                v-model="caseRecord.check_project.vision.MEM.OD"
                class="assayInput"
                size="small"
                placeholder="请输入内容"
              ></el-input>
            </span>
            <span>
              OS:
              <el-input
                v-model="caseRecord.check_project.vision.MEM.OS"
                class="assayInput"
                size="small"
                placeholder="请输入内容"
              ></el-input>
            </span>
            <span>
              OU:
              <el-input
                v-model="caseRecord.check_project.vision.MEM.OU"
                class="assayInput"
                size="small"
                placeholder="请输入内容"
              ></el-input>
            </span>
          </el-col>
        </el-row>
        <el-row :gutter="24" class="el-row-out">
          <el-col :span="3" class="titleCellItem el-col-right"
            >融合交叉柱镜（FCC）</el-col
          >
          <el-col :span="21" class="OverHeightCol">
            <span>
              OD:
              <el-input
                v-model="caseRecord.check_project.vision.FCC.OD"
                class="assayInput"
                size="small"
                placeholder="请输入内容"
              ></el-input>
            </span>
            <span>
              OS:
              <el-input
                v-model="caseRecord.check_project.vision.FCC.OS"
                class="assayInput"
                size="small"
                placeholder="请输入内容"
              ></el-input>
            </span>
            <span>
              OU:
              <el-input
                v-model="caseRecord.check_project.vision.FCC.OU"
                class="assayInput"
                size="small"
                placeholder="请输入内容"
              ></el-input>
            </span>
          </el-col>
        </el-row>
        <el-row :gutter="24" class="el-row-out">
          <el-col :span="3" class="titleCellItem el-col-right"
            >调节灵敏度</el-col
          >
          <el-col :span="21">
            <span>
              OD:
              <el-input
                v-model="caseRecord.check_project.vision.adjust_sensitivity.OD"
                class="assayInput"
                size="small"
                placeholder="请输入内容"
              ></el-input>
            </span>
            <span>
              OS:
              <el-input
                v-model="caseRecord.check_project.vision.adjust_sensitivity.OS"
                class="assayInput"
                size="small"
                placeholder="请输入内容"
              ></el-input>
            </span>
            <span>
              OU:
              <el-input
                v-model="caseRecord.check_project.vision.adjust_sensitivity.OU"
                class="assayInput"
                size="small"
                placeholder="请输入内容"
              ></el-input>
            </span>
          </el-col>
        </el-row>
        <el-row :gutter="24" class="el-row-out">
          <el-col :span="3" class="titleCellItem el-col-right">水平隐斜</el-col>
          <el-col :span="21">
            <span>
              (远用):
              <el-input
                v-model="
                  caseRecord.check_project.vision.horizontal_deviation.far
                "
                class="assayInput"
                size="small"
                placeholder="请输入内容"
              ></el-input>
            </span>
            <span>
              (近用):
              <el-input
                v-model="
                  caseRecord.check_project.vision.horizontal_deviation.near
                "
                class="assayInput"
                size="small"
                placeholder="请输入内容"
              ></el-input>
            </span>
          </el-col>
        </el-row>
        <el-row :gutter="24" class="el-row-out">
          <el-col :span="3" class="titleCellItem el-col-right">垂直隐斜</el-col>
          <el-col :span="21">
            <span>
              (远用):
              <el-input
                v-model="caseRecord.check_project.vision.vertical_deviation.far"
                class="assayInput"
                size="small"
                placeholder="请输入内容"
              ></el-input>
            </span>
            <span>
              (近用):
              <el-input
                v-model="
                  caseRecord.check_project.vision.vertical_deviation.near
                "
                class="assayInput"
                size="small"
                placeholder="请输入内容"
              ></el-input>
            </span>
          </el-col>
        </el-row>
        <el-row :gutter="24" class="el-row-out">
          <el-col :span="3" class="titleCellItem el-col-right">球镜度</el-col>
          <el-col :span="21">
            <span>
              加 + 1D:
              <el-input
                v-model="caseRecord.check_project.vision.spherical_power.plus"
                class="assayInput"
                size="small"
                placeholder="请输入内容"
              ></el-input>
            </span>
            <span>
              加 - 1D:
              <el-input
                v-model="
                  caseRecord.check_project.vision.spherical_power.subtract
                "
                class="assayInput"
                size="small"
                placeholder="请输入内容"
              ></el-input>
            </span>
          </el-col>
        </el-row>
        <el-row :gutter="24" class="el-row-out">
          <el-col :span="3" class="titleCellItem el-col-right">AC/A比</el-col>
          <el-col :span="21">
            <span>
              梯度法:
              <el-input
                v-model="caseRecord.check_project.vision.ac_a_compare.gradient"
                class="assayInput"
                size="small"
                placeholder="请输入内容"
              ></el-input>
            </span>
            <span>
              计算法:
              <el-input
                v-model="caseRecord.check_project.vision.ac_a_compare.calculus"
                class="assayInput"
                size="small"
                placeholder="请输入内容"
              ></el-input>
            </span>
          </el-col>
        </el-row>
        <el-row :gutter="24" class="el-row-out">
          <el-col :span="3" class="titleCellItem el-col-right"
            >负相对集合（NRV）</el-col
          >
          <el-col :span="21" class="OverHeightCol">
            <span>
              远: 水平 :
              <el-input
                v-model="caseRecord.check_project.vision.NRV.far_horizontal"
                class="assayInput"
                size="small"
                placeholder="请输入内容"
              ></el-input>
            </span>
            <span>
              近: 水平 :
              <el-input
                v-model="caseRecord.check_project.vision.NRV.near_horizontal"
                class="assayInput"
                size="small"
                placeholder="请输入内容"
              ></el-input>
            </span>
            <span>
              集合近点:
              <el-input
                v-model="caseRecord.check_project.vision.NRV.NPC"
                class="assayInput"
                size="small"
                placeholder="请输入内容"
              ></el-input>
            </span>
          </el-col>
        </el-row>
        <el-row :gutter="24" class="el-row-out">
          <el-col :span="3" class="titleCellItem el-col-right"
            >正相对性集合（PRV）</el-col
          >
          <el-col :span="21" class="OverHeightCol">
            <span>
              远: 水平 :
              <el-input
                v-model="caseRecord.check_project.vision.PRV.far_horizontal"
                class="assayInput"
                size="small"
                placeholder="请输入内容"
              ></el-input>
            </span>
            <span>
              近: 水平 :
              <el-input
                v-model="caseRecord.check_project.vision.PRV.near_horizontal"
                class="assayInput"
                size="small"
                placeholder="请输入内容"
              ></el-input>
            </span>
          </el-col>
        </el-row>
        <el-row :gutter="24" class="el-row-out">
          <el-col :span="3" class="titleCellItem el-col-right"
            >所用调节视标</el-col
          >
          <el-col :span="21" class="OverHeightCol">
            <span>
              OD:
              <el-input
                v-model="
                  caseRecord.check_project.vision.adjusting_visual_target.OD
                "
                class="assayInput"
                size="small"
                placeholder="请输入内容"
              ></el-input>
            </span>
            <span>
              OS:
              <el-input
                v-model="
                  caseRecord.check_project.vision.adjusting_visual_target.OS
                "
                class="assayInput"
                size="small"
                placeholder="请输入内容"
              ></el-input>
            </span>
            <span>
              OU:
              <el-input
                v-model="
                  caseRecord.check_project.vision.adjusting_visual_target.OU
                "
                class="assayInput"
                size="small"
                placeholder="请输入内容"
              ></el-input>
            </span>
          </el-col>
        </el-row>
        <el-row :gutter="24" class="el-row-out">
          <el-col :span="3" class="titelCellTextTitle">分析</el-col>
          <el-col :span="21" class="el-col-left">
            <el-input
              type="textarea"
              :rows="3"
              class="titelCellTextArea"
              placeholder="请输入内容"
              v-model="caseRecord.check_project.vision.analyse"
            ></el-input>
          </el-col>
        </el-row>
        <el-row :gutter="24" class="el-row-out">
          <el-col :span="3" class="titelCellTextTitle">处理意见</el-col>
          <el-col :span="21" class="el-col-left">
            <el-input
              type="textarea"
              :rows="3"
              class="titelCellTextArea"
              placeholder="请输入内容"
              v-model="caseRecord.check_project.vision.advice"
            ></el-input>
          </el-col>
        </el-row>
      </el-card>
      <div
        class="confirmButton"
        v-if="!enabledStationUUID || enabledStationUUID === stationId"
      >
        <el-button type="primary" @click="onClick" class="confirmButton"
          >提交</el-button
        >
      </div>
    </div>
    <div class="csContent" v-else>
      <el-card class="box-card caseRecordHead" shadow="never">
        <el-row :gutter="24">
          <el-col :span="2" class="titleCell">责任医师</el-col>
          <el-col :span="6">周医生</el-col>
          <el-col :span="2" class="titleCell">联系人</el-col>
          <el-col :span="6">陆文婷</el-col>
          <el-col :span="2" class="titleCell">病历日期</el-col>
          <el-col :span="6">2020-02-20</el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="2" class="titleCell">患者姓名</el-col>
          <el-col :span="6">杨春亭</el-col>
          <el-col :span="2" class="titleCell">性别</el-col>
          <el-col :span="6">男</el-col>
          <el-col :span="2" class="titleCell">出生日期</el-col>
          <el-col :span="6">2012-02-20</el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="2" class="titleCell">联系地址</el-col>
          <el-col :span="22">xxxxx</el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="2" class="titleCell">联系电话</el-col>
          <el-col :span="22">17600000004</el-col>
        </el-row>
      </el-card>
      <el-card class="box-card caseRecordHistory" shadow="never">
        <el-row :gutter="24" class="el-row-textarea">
          <el-col :span="2" class="titelCellTextTitle">主诉</el-col>
          <el-col :span="22">
            <span>{{ caseRecord.chief_complaint }}</span>
          </el-col>
        </el-row>
        <el-row :gutter="24" class="el-row-textarea">
          <el-col :span="2" class="titelCellTextTitle">眼部病史</el-col>
          <el-col :span="22">
            <span>{{ caseRecord.ophthalmopathy_history }}</span>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="2" class="titleCell">治疗史</el-col>
          <el-col :span="22">
            <span>{{ caseRecord.treatment_history }}</span>
          </el-col>
        </el-row>
      </el-card>
      <el-card class="box-card caseRecordAssay" shadow="never">
        <el-row :gutter="24">
          <el-col :span="2" class="titleCell">项目</el-col>
          <el-col :span="11" class="titleCell">右眼(OD)</el-col>
          <el-col :span="11" class="titleCell">左眼(OS)</el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="2" class="titleCellItem">
            视力
            <span class="mustItem">*</span>(标准对数)
          </el-col>
          <el-col :span="22">
            <el-row :gutter="24">
              <el-col :span="12">
                戴镜远视力:
                <span>{{
                  caseRecord.check_project.vision.OD.far_vision_with_glasses
                }}</span>
              </el-col>
              <el-col :span="12">
                戴镜近视力:
                <span>{{
                  caseRecord.check_project.vision.OD.near_vision_with_glasses
                }}</span>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12">
                戴镜远视力:
                <span>{{
                  caseRecord.check_project.vision.OS.far_vision_with_glasses
                }}</span>
              </el-col>
              <el-col :span="12">
                戴镜近视力:
                <span>{{
                  caseRecord.check_project.vision.OS.near_vision_with_glasses
                }}</span>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="2" class="titleCellItem">验光度数</el-col>
          <el-col :span="22">
            <el-row :gutter="24">
              <el-col :span="12">
                <el-switch
                  v-model="checked"
                  active-text="+"
                  inactive-text="-"
                />
                <el-input-number
                  v-model="caseRecord.check_project.vision.eye_degree"
                  :precision="2"
                  :step="0.25"
                  :step-strictly="true"
                  controls-position="right"
                  class="eyeDegreeNumberInput"
                  size="mini"
                ></el-input-number
                >/
                <el-input-number
                  v-model="num"
                  :precision="2"
                  :step="0.25"
                  :step-strictly="true"
                  controls-position="right"
                  class="eyeDegreeNumberInput"
                  size="mini"
                ></el-input-number
                >×
                <el-input-number
                  v-model="num"
                  :controls="false"
                  :step-strictly="true"
                  :max="360"
                  :min="0"
                  class="eyeDegreeNumberInput"
                  size="mini"
                ></el-input-number>
              </el-col>
              <el-col :span="12">
                <el-switch
                  v-model="checked"
                  active-text="+"
                  inactive-text="-"
                />
                <el-input-number
                  v-model="num"
                  :precision="2"
                  :step="0.25"
                  :step-strictly="true"
                  controls-position="right"
                  class="eyeDegreeNumberInput"
                  size="mini"
                ></el-input-number
                >/
                <el-input-number
                  v-model="num"
                  :precision="2"
                  :step="0.25"
                  :step-strictly="true"
                  controls-position="right"
                  class="eyeDegreeNumberInput"
                  size="mini"
                ></el-input-number
                >×
                <el-input-number
                  v-model="num"
                  :controls="false"
                  :step-strictly="true"
                  :max="360"
                  :min="0"
                  class="eyeDegreeNumberInput"
                  size="mini"
                ></el-input-number>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="24">
                戴镜时间：
                <el-date-picker
                  v-model="
                    caseRecord.check_project.vision.eye_degree
                      .time_of_wearing_glasses
                  "
                  type="date"
                  placeholder="选择日期"
                  class="eyeDegreeDateSelect"
                  size="mini"
                ></el-date-picker>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="2" class="titleCellItem">注视性质</el-col>
          <el-col :span="11">
            <span>{{
              caseRecord.check_project.vision.fixation_property.OD || "-"
            }}</span>
          </el-col>
          <el-col :span="11">
            <span>{{
              caseRecord.check_project.vision.fixation_property.OS || "-"
            }}</span>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="2" class="titleCellItem">
            弱视类型
            <span class="mustItem">*</span>
          </el-col>
          <el-col :span="11">
            <span>{{
              caseRecord.check_project.vision.amblyopia_type.OD || "-"
            }}</span>
          </el-col>
          <el-col :span="11">
            <span>{{
              caseRecord.check_project.vision.amblyopia_type.OS || "-"
            }}</span>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="2" class="titleCellItem">
            同时知觉
            <span class="mustItem">*</span>
          </el-col>
          <el-col :span="22">
            <el-row :gutter="24">
              <el-col :span="4" class="titleCellItem">四孔检查</el-col>
              <el-col :span="20">
                <el-row :gutter="24">
                  <el-col :span="24">
                    <span
                      >远：{{
                        caseRecord.check_project.vision.simultaneous_perception
                          .four_hole_inspection.far || "-"
                      }}</span
                    >
                    <span
                      >近：{{
                        caseRecord.check_project.vision.simultaneous_perception
                          .four_hole_inspection.near || "-"
                      }}</span
                    >
                  </el-col>
                </el-row>
                <el-row :gutter="24">
                  <el-col :span="24">
                    主导眼:
                    <span>{{
                      caseRecord.check_project.vision.simultaneous_perception
                        .four_hole_inspection.dominant_eye
                    }}</span>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="4" class="titleCellItem">偏差检查</el-col>
              <el-col :span="20">
                <span class="assayInputSmallSpan">
                  水平偏差：
                  <span>{{
                    caseRecord.check_project.vision.simultaneous_perception
                      .deviation_check.horizontal || "-"
                  }}</span>
                  度
                </span>
                <span>
                  垂直偏差：
                  <span>{{
                    caseRecord.check_project.vision.simultaneous_perception
                      .deviation_check.vertical || "-"
                  }}</span>
                  度
                </span>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="4" class="titleCellItem">同时机检查</el-col>
              <el-col :span="20">
                <el-radio-group
                  v-model="
                    caseRecord.check_project.vision.simultaneous_perception
                      .synoptophore_inspection.has
                  "
                >
                  <el-radio :label="true">有同时知觉</el-radio>
                  <el-radio :label="false">无同时知觉</el-radio>
                </el-radio-group>
                <span>
                  <el-input
                    v-model="
                      caseRecord.check_project.vision.simultaneous_perception
                        .synoptophore_inspection.content
                    "
                    class="assayInputBig"
                    size="small"
                  ></el-input>
                </span>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="2" class="titleCellItem">融合功能</el-col>
          <el-col :span="22">
            <el-row :gutter="24">
              <el-col :span="4" class="titleCellItem">线条融合</el-col>
              <el-col :span="20">
                <span class="assayInputSmallSpan">
                  分开范围 -
                  <span>{{
                    caseRecord.check_project.vision.fusion.line_blending
                      .separate_range || "-"
                  }}</span>
                  度
                </span>
                <span>
                  辐辏范围: +
                  <span>{{
                    caseRecord.check_project.vision.fusion.line_blending
                      .convergence_range || "-"
                  }}</span>
                  度
                </span>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="4" class="titleCellItem">
                随机点融合(800秒)
                <span class="mustItem">*</span>
              </el-col>
              <el-col :span="20">
                <span class="assayInputSmallSpan">
                  分开范围: -
                  <span>{{
                    caseRecord.check_project.vision.fusion.random_point_fusion
                      .separate_range || "-"
                  }}</span>
                  度
                </span>
                <span>
                  辐辏范围: +
                  <span>{{
                    caseRecord.check_project.vision.fusion.random_point_fusion
                      .convergence_range || "-"
                  }}</span>
                  度
                </span>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="4" class="titleCellItem">同时机</el-col>
              <el-col :span="20">
                <span class="assayInputSmallSpan">
                  分开范围: -
                  <span>{{
                    caseRecord.check_project.vision.fusion.synoptophore
                      .separate_range || "-"
                  }}</span>
                  度
                </span>
                <span>
                  辐辏范围: +
                  <span>{{
                    caseRecord.check_project.vision.fusion.synoptophore
                      .convergence_range || "-"
                  }}</span>
                  度
                </span>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="2" class="titleCellItem">立体视觉</el-col>
          <el-col :span="22">
            <el-row :gutter="24">
              <el-col :span="4" class="titleCellItem">远</el-col>
              <el-col :span="20">
                <span>
                  同视机:
                  <span>{{
                    caseRecord.check_project.vision.stereoscopic_vision.far
                      .synoptophore || "-"
                  }}</span>
                </span>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="4" class="titleCellItem">近</el-col>
              <el-col :span="20">
                <el-row :gutter="24">
                  <el-col :span="24">
                    <span>
                      线条立体视:
                      <span>{{
                        caseRecord.check_project.vision.stereoscopic_vision.near
                          .line_stereopsis || "-"
                      }}</span>
                    </span>
                    <span>
                      静态随机点:
                      <span>{{
                        caseRecord.check_project.vision.stereoscopic_vision.near
                          .static_random_point || "-"
                      }}</span>
                    </span>
                    <span>
                      动态随机点:
                      <span>{{
                        caseRecord.check_project.vision.stereoscopic_vision.near
                          .dynamic_random_point || "-"
                      }}</span>
                    </span>
                  </el-col>
                </el-row>
                <el-row :gutter="24">
                  <el-col :span="24">
                    <span>
                      颜氏:
                      <span>{{
                        caseRecord.check_project.vision.stereoscopic_vision.near
                          .yan_style || "-"
                      }}</span>
                    </span>
                    <span>
                      Titmus:
                      <span>{{
                        caseRecord.check_project.vision.stereoscopic_vision.near
                          .Titmus || "-"
                      }}</span>
                    </span>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="2" class="titleCellItem">斜视</el-col>
          <el-col :span="22">
            <span>{{ caseRecord.check_project.vision.squint || "-" }}</span>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="2" class="titleCellItem">调节幅度</el-col>
          <el-col :span="22">
            <span>
              OD:
              <span>{{ caseRecord.check_project.vision.AMP.OD || "-" }}</span>
            </span>
            <span>
              OS:
              <span>{{ caseRecord.check_project.vision.AMP.OS || "-" }}</span>
            </span>
            <span>
              OU:
              <span>{{ caseRecord.check_project.vision.AMP.OU || "-" }}</span>
            </span>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="2" class="titleCellItem">负相对调节（NRA）</el-col>
          <el-col :span="22" class="OverHeightCol">
            <span>
              OD:
              <span>{{ caseRecord.check_project.vision.NRA.OD || "-" }}</span>
            </span>
            <span>
              OS:
              <span>{{ caseRecord.check_project.vision.NRA.OS || "-" }}</span>
            </span>
            <span>
              OU:
              <span>{{ caseRecord.check_project.vision.NRA.OU || "-" }}</span>
            </span>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="2" class="titleCellItem">正相对调节（PRA）</el-col>
          <el-col :span="22" class="OverHeightCol">
            <span>
              OD:
              <span>{{ caseRecord.check_project.vision.PRA.OD || "-" }}</span>
            </span>
            <span>
              OS:
              <span>{{ caseRecord.check_project.vision.PRA.OS || "-" }}</span>
            </span>
            <span>
              OU:
              <span>{{ caseRecord.check_project.vision.PRA.OU || "-" }}</span>
            </span>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="2" class="titleCellItem">MEM动态检影法</el-col>
          <el-col :span="22" class="OverHeightCol">
            <span>
              OD:
              <span>{{ caseRecord.check_project.vision.MEM.OD || "-" }}</span>
            </span>
            <span>
              OS:
              <span>{{ caseRecord.check_project.vision.MEM.OS || "-" }}</span>
            </span>
            <span>
              OU:
              <span>{{ caseRecord.check_project.vision.MEM.OU || "-" }}</span>
            </span>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="2" class="titleCellItem">融合交叉柱镜（FCC）</el-col>
          <el-col :span="22" class="OverHeightCol">
            <span>
              OD:
              <span>{{ caseRecord.check_project.vision.FCC.OD || "-" }}</span>
            </span>
            <span>
              OS:
              <span>{{ caseRecord.check_project.vision.FCC.OS || "-" }}</span>
            </span>
            <span>
              OU:
              <span>{{ caseRecord.check_project.vision.FCC.OU || "-" }}</span>
            </span>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="2" class="titleCellItem">调节灵敏度</el-col>
          <el-col :span="22">
            <span>
              OD:
              <span>{{
                caseRecord.check_project.vision.adjust_sensitivity.OD || "-"
              }}</span>
            </span>
            <span>
              OS:
              <span>{{
                caseRecord.check_project.vision.adjust_sensitivity.OS || "-"
              }}</span>
            </span>
            <span>
              OU:
              <span>{{
                caseRecord.check_project.vision.adjust_sensitivity.OU || "-"
              }}</span>
            </span>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="2" class="titleCellItem">水平隐斜</el-col>
          <el-col :span="22">
            <span>
              (远用):
              <span>{{
                caseRecord.check_project.vision.horizontal_deviation.far || "-"
              }}</span>
            </span>
            <span>
              (近用):
              <span>{{
                caseRecord.check_project.vision.horizontal_deviation.near || "-"
              }}</span>
            </span>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="2" class="titleCellItem">垂直隐斜</el-col>
          <el-col :span="22">
            <span>
              (远用):
              <span>{{
                caseRecord.check_project.vision.vertical_deviation.far || "-"
              }}</span>
            </span>
            <span>
              (近用):
              <span>{{
                caseRecord.check_project.vision.vertical_deviation.near || "-"
              }}</span>
            </span>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="2" class="titleCellItem">球镜度</el-col>
          <el-col :span="22">
            <span>
              加 + 1D:
              <span>{{
                caseRecord.check_project.vision.spherical_power.plus || "-"
              }}</span>
            </span>
            <span>
              加 - 1D:
              <span>{{
                caseRecord.check_project.vision.spherical_power.subtract || "-"
              }}</span>
            </span>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="2" class="titleCellItem">AC/A比</el-col>
          <el-col :span="22">
            <span>
              梯度法:
              <span>{{
                caseRecord.check_project.vision.ac_a_compare.gradient || "-"
              }}</span>
            </span>
            <span>
              计算法:
              <span>{{
                caseRecord.check_project.vision.ac_a_compare.calculus || "-"
              }}</span>
            </span>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="2" class="titleCellItem">负相对集合（NRV）</el-col>
          <el-col :span="22" class="OverHeightCol">
            <span>
              远: 水平 :
              <span>{{
                caseRecord.check_project.vision.NRV.far_horizontal || "-"
              }}</span>
            </span>
            <span>
              近: 水平 :
              <span>{{
                caseRecord.check_project.vision.NRV.near_horizontal || "-"
              }}</span>
            </span>
            <span>
              集合近点:
              <span>{{ caseRecord.check_project.vision.NRV.NPC || "-" }}</span>
            </span>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="2" class="titleCellItem">正相对性集合（PRV）</el-col>
          <el-col :span="22" class="OverHeightCol">
            <span>
              远: 水平 :
              <span>{{
                caseRecord.check_project.vision.PRV.far_horizontal || "-"
              }}</span>
            </span>
            <span>
              近: 水平 :
              <span>{{
                caseRecord.check_project.vision.PRV.near_horizontal || "-"
              }}</span>
            </span>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="2" class="titleCellItem">所用调节视标</el-col>
          <el-col :span="22" class="OverHeightCol">
            <span>
              OD:
              <span>{{
                caseRecord.check_project.vision.adjusting_visual_target.OD ||
                "-"
              }}</span>
            </span>
            <span>
              OS:
              <span>{{
                caseRecord.check_project.vision.adjusting_visual_target.OS ||
                "-"
              }}</span>
            </span>
            <span>
              OU:
              <span>{{
                caseRecord.check_project.vision.adjusting_visual_target.OU ||
                "-"
              }}</span>
            </span>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="2" class="titelCellTextTitle">分析</el-col>
          <el-col :span="22">
            <span>{{ caseRecord.check_project.vision.analyse || "-" }}</span>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="2" class="titelCellTextTitle">处理意见</el-col>
          <el-col :span="22">
            <span>{{
              caseRecord.check_project.vision.analyse.advice || "-"
            }}</span>
          </el-col>
        </el-row>
      </el-card>
    </div>
  </div>
</template>

<style lang="scss">
@import "@/css/color.scss";

.PatientManagementCaseRecordIndex {
  .headerLinkView {
    padding-top: 10px;
    padding-left: 10px;
    .el-breadcrumb__inner.is-link,
    .el-breadcrumb__inner a {
      color: #00c1de;
    }
  }
  .csContentEdit {
    .caseRecordHead {
      margin: 15px 1%;
      border: 0px;
      margin-bottom: -35px;
      .el-row {
        display: flex;
        // flex-wrap: wrap;
        align-items: flex-start;
        border-left: 1px solid #e8e8e8;
        border-top: 1px solid #e8e8e8;
        line-height: 40px;
        &:last-child {
          // margin-bottom: 0;
          border-bottom: 1px solid #e8e8e8;
        }
      }
      .titleCell {
        background-color: #fafafa;
        text-align: center;
      }
      .el-col {
        border-right: 1px solid #e8e8e8;
        font-size: 14px;
        color: #596063;
        letter-spacing: -0.28px;
      }
    }
    .caseRecordHistory {
      margin: 15px 1%;
      border: 0px;
      margin-bottom: -35px;
      .el-row-textarea {
        display: flex;
        // flex-wrap: wrap;
        align-items: flex-start;
        border-left: 1px solid #e8e8e8;
        border-top: 1px solid #e8e8e8;
        line-height: 85px;
        &:last-child {
          // margin-bottom: 0;
          border-bottom: 1px solid #e8e8e8;
        }
      }
      .el-row {
        display: flex;
        // flex-wrap: wrap;
        align-items: flex-start;
        border-left: 1px solid #e8e8e8;
        border-top: 1px solid #e8e8e8;
        line-height: 40px;
        &:last-child {
          // margin-bottom: 0;
          border-bottom: 1px solid #e8e8e8;
        }
      }
      .titleCell {
        background-color: #fafafa;
        text-align: center;
      }
      .titelCellTextTitle {
        line-height: 85px;
        background-color: #fafafa;
        text-align: center;
      }
      .titelCellTextArea {
        padding: 5px;
      }
      .el-col {
        border-right: 1px solid #e8e8e8;
        font-size: 14px;
        color: #596063;
        letter-spacing: -0.28px;
      }
    }
    .el-radio__input.is-checked .el-radio__inner {
      border-color: #00c1de;
      background-color: #fff;
    }

    .el-radio__inner:after {
      background-color: #00c1de;
    }

    .el-radio__input.is-checked + .el-radio__label {
      color: #00c1de;
    }

    .el-checkbox__input.is-checked + .el-checkbox__label {
      color: #00c1de;
    }

    .el-checkbox__input.is-checked .el-checkbox__inner,
    .el-checkbox__input.is-indeterminate .el-checkbox__inner {
      border-color: #00c1de;
      background-color: #00c1de;
    }
    .el-select .el-input.is-focus .el-input__inner {
      border-color: #00c1de;
    }
    .el-select-dropdown__item.hover {
      color: #00c1de;
    }
    .el-input.is-active .el-input__inner,
    .el-input__inner:focus {
      border-color: #00c1de;
    }
    .el-input.is-active .el-input__inner,
    .el-input__inner:hover {
      border-color: #00c1de;
    }
    .caseRecordAssay {
      margin: 15px 1%;
      border: 0px;
      .el-row {
        display: flex;
        // flex-wrap: wrap;
        align-items: flex-start;
        // border: 1px solid #e8e8e8;
        line-height: 40px;
      }
      .el-row-out {
        border-top: 1px solid #e8e8e8;
        border-right: 1px solid #e8e8e8;
        border-left: 1px solid #e8e8e8;
        &:last-child {
          // margin-bottom: 0;
          border-bottom: 1px solid #e8e8e8;
        }
      }
      .el-row-in {
        border-bottom: 1px solid #e8e8e8;
        // border-right: 1px solid #e8e8e8;
        // border-left: 1px solid #e8e8e8;
      }
      .el-col-right {
        border-right: 1px solid #e8e8e8;
      }
      .el-col-left {
        border-left: 1px solid #e8e8e8;
      }
      .titleCell {
        background-color: #fafafa;
        text-align: center;
      }
      .titleCellItem {
        text-align: center;
        margin: auto;
      }
      .el-col {
        // border-right: 1px solid #e8e8e8;
        // border-left: 1px solid #e8e8e8;
        font-size: 14px;
        color: #596063;
        letter-spacing: -0.28px;
        //    margin-left: -1px;
        // &:last-child {
        //   border-right: none;
        // }
        // &:first-child {
        //   border-right: none;
        //   border-left: none;
        // }
      }
      .rmBorderRow {
        border: none !important;
      }
      .rmBorderCol {
        border: none !important;
      }
      .titelCellTextTitle {
        line-height: 85px;
        //   background-color: #fafafa;
        text-align: center;
      }
      .titelCellTextArea {
        padding: 5px;
      }
      .assayInput {
        width: 200px;
        margin: auto 10px;
      }
      .eyeDegreeInput {
        width: 100px;
        margin-left: 5px;
      }
      .eyeDegreeNumberInput {
        width: 100px;
        margin-right: 5px;
        margin-left: 5px;
        // padding-right: 40px
      }
      .eyeDegreeSelect {
        width: 120px;
        margin: auto 18px auto 10px;
      }
      .eyeDegreeDateSelect {
        width: 150px;
      }
      .OverHeightCol {
        // line-height: 80px;
        margin: auto;
      }
      .eyeAssayRadioGroup {
        margin: auto 20px auto 5px;
      }
      .assayInputSmallSpan {
        display: inline-block;
        margin-right: 25px;
      }
      .assayInputSmall {
        width: 100px;
        margin-right: 5px;
      }
      .assayInputBig {
        width: 350px;
      }
    }
    .confirmButton {
      text-align: center;
      margin-bottom: 15px;
      .el-button--primary {
        background-color: #00c1de;
        border-color: #00c1de;
      }
    }
    .mustItem {
      color: red;
    }
    .warning-Item {
      border: 1px solid red !important;
    }
  }
  .csContent {
    .caseRecordHead {
      margin: 15px 1%;
      border: 0px;
      margin-bottom: -35px;
      .el-row {
        display: flex;
        flex-wrap: wrap;
        align-items: flex-start;
        border-left: 1px solid #e8e8e8;
        border-top: 1px solid #e8e8e8;
        line-height: 40px;
        &:last-child {
          // margin-bottom: 0;
          border-bottom: 1px solid #e8e8e8;
        }
      }
      .titleCell {
        background-color: #fafafa;
        text-align: center;
      }
      .el-col {
        border-right: 1px solid #e8e8e8;
        font-size: 14px;
        color: #596063;
        letter-spacing: -0.28px;
      }
    }
    .caseRecordHistory {
      margin: 15px 1%;
      border: 0px;
      margin-bottom: -35px;
      .el-row-textarea {
        display: flex;
        // flex-wrap: wrap;
        align-items: flex-start;
        border-left: 1px solid #e8e8e8;
        border-top: 1px solid #e8e8e8;
        line-height: 85px;
        &:last-child {
          // margin-bottom: 0;
          border-bottom: 1px solid #e8e8e8;
        }
      }
      .el-row {
        display: flex;
        // flex-wrap: wrap;
        align-items: flex-start;
        border-left: 1px solid #e8e8e8;
        border-top: 1px solid #e8e8e8;
        line-height: 40px;
        &:last-child {
          // margin-bottom: 0;
          border-bottom: 1px solid #e8e8e8;
        }
      }
      .titleCell {
        background-color: #fafafa;
        text-align: center;
      }
      .titelCellTextTitle {
        line-height: 85px;
        background-color: #fafafa;
        text-align: center;
      }
      .titelCellTextArea {
        padding: 5px;
      }
      .el-col {
        border-right: 1px solid #e8e8e8;
        font-size: 14px;
        color: #596063;
        letter-spacing: -0.28px;
      }
    }
    .el-radio__input.is-checked .el-radio__inner {
      border-color: #00c1de;
      background-color: #fff;
    }

    .el-radio__inner:after {
      background-color: #00c1de;
    }

    .el-radio__input.is-checked + .el-radio__label {
      color: #00c1de;
    }

    .el-checkbox__input.is-checked + .el-checkbox__label {
      color: #00c1de;
    }

    .el-checkbox__input.is-checked .el-checkbox__inner,
    .el-checkbox__input.is-indeterminate .el-checkbox__inner {
      border-color: #00c1de;
      background-color: #00c1de;
    }
    .el-select .el-input.is-focus .el-input__inner {
      border-color: #00c1de;
    }
    .el-select-dropdown__item.hover {
      color: #00c1de;
    }
    .el-input.is-active .el-input__inner,
    .el-input__inner:focus {
      border-color: #00c1de;
    }
    .el-input.is-active .el-input__inner,
    .el-input__inner:hover {
      border-color: #00c1de;
    }
    .caseRecordAssay {
      margin: 15px 1%;
      border: 0px;
      .el-row {
        display: flex;
        // flex-wrap: wrap;
        align-items: flex-start;
        border: 1px solid #e8e8e8;
        border-top: 1px solid #e8e8e8;

        line-height: 40px;
        &:last-child {
          // margin-bottom: 0;
          border-bottom: 1px solid #e8e8e8;
        }
      }
      .titleCell {
        background-color: #fafafa;
        text-align: center;
      }
      .titleCellItem {
        text-align: center;
        margin: auto;
      }
      .el-col {
        border-right: 1px solid #e8e8e8;
        border-left: 1px solid #e8e8e8;
        font-size: 14px;
        color: #596063;
        letter-spacing: -0.28px;
        //    margin-left: -1px;
        &:last-child {
          border-right: none;
        }
        &:first-child {
          border-right: none;
          border-left: none;
        }
      }
      .titelCellTextTitle {
        line-height: 85px;
        //   background-color: #fafafa;
        text-align: center;
      }
      .titelCellTextArea {
        padding: 5px;
      }
      .assayInput {
        width: 200px;
        margin: auto 10px;
      }
      .eyeDegreeInput {
        width: 100px;
        margin-left: 5px;
      }
      .eyeDegreeNumberInput {
        width: 100px;
        margin-right: 5px;
        margin-left: 5px;
      }
      .eyeDegreeSelect {
        width: 100px;
        margin: auto 18px auto 10px;
      }
      .eyeDegreeDateSelect {
        width: 150px;
      }
      .OverHeightCol {
        line-height: 80px;
      }
      .eyeAssayRadioGroup {
        margin: auto 20px auto 5px;
      }
      .assayInputSmallSpan {
        display: inline-block;
        margin-right: 25px;
      }
      .assayInputSmall {
        width: 100px;
        margin-right: 5px;
      }
      .assayInputBig {
        width: 350px;
      }
    }
    .confirmButton {
      text-align: center;
      margin-bottom: 15px;
      .el-button--primary {
        background-color: #00c1de;
        border-color: #00c1de;
      }
    }
    .mustItem {
      color: red;
    }
    .warning-Item {
      border: 1px solid red;
    }
  }
}
</style>





// WEBPACK FOOTER //
// src/components/patientManagement/caseRecord.vue